import React from "react";
import { useTranslation } from "react-i18next";

const years = [
  1990,
  1992,
  1994,
  1996,
  1998,
  2000,
  2002,
  2004,
  2006,
  2008,
  2010,
  2012,
  2014,
  2016,
  2018,
  "2020/2021",
  2024,
  2026,
];

function ChinWooWorldChampionships() {
  const { t } = useTranslation();

  return (
    <section className="pt-12 pb-12 bg-white dark:bg-slate-800 transition-colors relative z-10" id="history">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-5xl mb-5 text-primary dark:text-primary-light relative inline-block">
            {t("chinwooWorldChampionships.title")}
            {/* Underline decoration */}
            <div className="absolute -bottom-2.5 left-1/2 transform -translate-x-1/2 w-15 h-0.5 bg-primary dark:bg-primary-light rounded-sm" />
          </h2>
          <p className="text-slate-600 dark:text-slate-400 mt-4 text-lg max-w-3xl mx-auto">
            {t("chinwooWorldChampionships.description")}
          </p>
        </div>

        {/* Timeline Container */}
        <div className="relative">
          {/* Vertical Timeline Line - Hidden on mobile, visible on tablet+ */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-gradient-to-b from-primary/30 via-primary/50 to-primary/30 dark:from-primary-light/30 dark:via-primary-light/50 dark:to-primary-light/30"></div>

          {/* Timeline Items */}
          <div className="space-y-8 md:space-y-12">
            {years.map((year, index) => {
              const eventData = t(`chinwooWorldChampionships.events.${year}`, { returnObjects: true });
              const isEven = index % 2 === 0;
              const isLast = index === years.length - 1;

              return (
                <div
                  key={year}
                  className={`relative flex flex-col md:flex-row items-center gap-6 ${
                    isEven ? "md:flex-row" : "md:flex-row-reverse"
                  }`}
                >
                  {/* Timeline Dot - Hidden on mobile */}
                  <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-4 h-4 rounded-full bg-primary dark:bg-primary-light border-4 border-white dark:border-slate-900 shadow-lg z-10"></div>

                  {/* Content Card */}
                  <div
                    className={`w-full md:w-5/12 bg-slate-50 dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm p-6 hover:shadow-md transition-all duration-200 relative ${
                      isEven ? "md:mr-auto md:pr-8" : "md:ml-auto md:pl-8"
                    }`}
                  >
                    {/* Championship Number Badge - oben in der strahlnahen Ecke */}
                    <div className={`absolute top-4 z-10 ${
                      isEven ? "right-4" : "left-4"
                    }`}>
                      <div className="w-10 h-10 rounded-full bg-primary/10 dark:bg-primary-light/20 border-2 border-primary/30 dark:border-primary-light/30 flex items-center justify-center shadow-sm">
                        <span className="text-sm font-semibold text-primary dark:text-primary-light">{index + 1}.</span>
                      </div>
                    </div>

                    <div className={`flex items-start gap-4 ${
                      isEven ? "flex-row" : "flex-row-reverse"
                    }`}>
                      {/* Flag Image - immer auf der strahlfernen Seite */}
                      <div className="flex-shrink-0 relative">
                        <img
                          src={eventData.flag}
                          alt={`${eventData.country} flag`}
                          className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-full border-2 border-slate-200 dark:border-slate-700 shadow-sm"
                        />
                      </div>

                      {/* Content - bündig zur strahlfernen Seite */}
                      <div className={`flex-1 min-w-0 ${
                        isEven ? "text-left" : "text-right"
                      }`}>
                        {/* Year Badge */}
                        <div className={`inline-block px-3 py-1 mb-3 bg-primary/10 dark:bg-primary-light/20 text-primary dark:text-primary-light text-sm font-semibold rounded-full ${
                          isEven ? "" : "md:ml-auto"
                        }`}>
                          {year}
                        </div>

                        {/* Country */}
                        <h3 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-2">
                          {eventData.country}
                        </h3>

                        {/* Location */}
                        <div className={`flex items-center gap-2 text-slate-600 dark:text-slate-400 ${
                          isEven ? "justify-start" : "justify-end"
                        }`}>
                          <i className="fas fa-map-marker-alt text-sm"></i>
                          <p className="text-sm">{eventData.location}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Spacer for alternating layout - Hidden on mobile */}
                  <div className="hidden md:block md:w-2/12"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ChinWooWorldChampionships;
